// #region Tipo Media para la parte multimedia de Init
export enum MediaType {
    Image = "IM",
    Video = "VI",
}
// #endregion

// #region Estados del registro del usuario
export enum StateUser {
    Inactive = 1,
    oK,
    IncorrectData,
    PendingConfirmation,
    PendingValidation,
}
// #endregion

// #region Estado de una reserva
export enum StateReservations {
    Pending = 1,
    Regularized = 2,
    Validated = 3,
    Cancelled = 4,
    Duplicated = 5,
    Rejected = 6
}
// #endregion

// #region Tipo de dato
export enum IncreaseInfo {
    porcent = 0,
    currency = 1
}
// #endregion

//#region AjaxApi response types
export enum ApiResponseStatus {
    NoShow = "NoShow",
    Success = "Success",
    Error = "Error",
    Warning = "Warning",
    Information = "Information",
    Validation = "Validation"
}

// #endregion

//#region Academy Status

export enum AcademyStatus {
    BADGE_STATUS_INACTIVE,          // La insignia no puede ser obtenida y no ha sido otorgada.
    BADGE_STATUS_ACTIVE,            // La insignia puede ser obtenida, pero aún no ha sido otorgada.
    BADGE_STATUS_INACTIVE_LOCKED2,   // La insignia ya no puede ser obtenida, pero ha sido otorgada en el pasado.
    BADGE_STATUS_ACTIVE_LOCKED,     // La insignia puede ser obtenida y ha sido otorgada, pero no se pueden hacer más cambios.
    BADGE_STATUS_ARCHIVED           // La insignia se considera eliminada y no se muestra en la lista de insignias disponibles.
}
//#endregion